document.addEventListener("DOMContentLoaded", function() {
    setTimeout(function() {
        initStickyAddToCart()
    }, 500);

    function initStickyAddToCart() {
        const stickyElement = document.getElementById("stickyAddToCart"),
            addToCartSelectors = ['button[name="add"]', "button.add-to-cart", "button.add-to-cart-button", "button.product-form__cart-submit", "button.product-form__submit", 'form[action*="/cart/add"] button[type="submit"]', ".ProductForm__AddToCart"];
        let addToCartButton = null;
        for (const selector of addToCartSelectors) {
            const button = document.querySelector(selector);
            if (button) {
                addToCartButton = button;
                break
            }
        }
        if (addToCartButton) setupScrollHandler();
        else {
            const observer = new MutationObserver(function(mutations) {
                for (const selector of addToCartSelectors) {
                    const button = document.querySelector(selector);
                    if (button) {
                        addToCartButton = button, observer.disconnect(), setupScrollHandler();
                        break
                    }
                }
            });
            observer.observe(document.body, {
                childList: !0,
                subtree: !0
            }), setTimeout(function() {
                observer.disconnect()
            }, 1e4)
        }

        function setupScrollHandler() {
            let isVisible = !1,
                debounceTimer = null;

            function handleScroll() {

                if (!addToCartButton) return;

                const desktopShipping = document.querySelector(".sticky-add-to-cart__shipping"),
                    mobileShipping = document.querySelector(".mobile-shipping-info");

                if (
                desktopShipping &&
                window.stickySettings &&
                (
                    window.stickySettings.showDesktopShipping === false ||
                    window.stickySettings.showDeliveryDate === false
                )
                ) {
                desktopShipping.style.display = "none";
                desktopShipping.setAttribute("aria-hidden", "true");
                }

                if (
                mobileShipping &&
                window.stickySettings &&
                (
                    window.stickySettings.showMobileShipping === false ||
                    window.stickySettings.showDeliveryDate === false
                )
                ) {
                mobileShipping.style.display = "none";
                mobileShipping.setAttribute("aria-hidden", "true");
                }

                const cartDrawerWrapper = document.querySelector(
                "cart-drawer.drawer, .drawer.cart-drawer, .cart-drawer"
                );

                const cartSidebar = document.querySelector(
                "#sidebar-cart, #CartDrawer, .cart-sidebar"
                );

                if (
                (
                    cartDrawerWrapper &&
                    (
                    cartDrawerWrapper.classList.contains("active") ||
                    cartDrawerWrapper.classList.contains("is-open") ||
                    cartDrawerWrapper.classList.contains("drawer--is-open") ||
                    cartDrawerWrapper.hasAttribute("open") ||
                    cartDrawerWrapper.getAttribute("aria-hidden") === "false"
                    )
                ) ||
                (
                    cartSidebar &&
                    (
                    cartSidebar.classList.contains("is-open") ||
                    cartSidebar.classList.contains("drawer--is-open") ||
                    cartSidebar.getAttribute("aria-hidden") === "false"
                    )
                )
                ) {
                hideStickyButton();
                return;
                }

                // UPDATED LOGIC
                const buttonRect = addToCartButton.getBoundingClientRect();

                // button viewport ni upar jase etle sticky show thase
                const shouldBeVisible = buttonRect.top < 0;

                if (shouldBeVisible !== isVisible) {

                clearTimeout(debounceTimer);

                debounceTimer = setTimeout(() => {

                    if (shouldBeVisible) {
                    showStickyButton();
                    } else {
                    hideStickyButton();
                    }

                }, 50);

                }
            }

            function showStickyButton() {
                isVisible || (stickyElement.style.display = "block", stickyElement.offsetWidth, stickyElement.classList.add("show"), isVisible = !0)
            }

            function hideStickyButton() {
                isVisible && (stickyElement.classList.remove("show"), setTimeout(() => {
                    stickyElement.classList.contains("show") || (stickyElement.style.display = "none"), isVisible = !1
                }, 400))
            }
            window.addEventListener("scroll", handleScroll, {
                passive: !0
            }), window.addEventListener("resize", handleScroll, {
                passive: !0
            }), document.addEventListener("click", function(e) {
                e.target.closest('[data-action="open-drawer"], [data-open-cart], .js-drawer-open-cart, .cart-link') && setTimeout(handleScroll, 100)
            }), document.addEventListener("cart:open", handleScroll), document.addEventListener("cart-drawer:open", handleScroll), document.addEventListener("cart.requestStarted", handleScroll), document.addEventListener("cartDrawerOpened", handleScroll);
            const drawerObserver = new MutationObserver(function(mutations) {
                for (let mutation of mutations) mutation.type === "attributes" && (mutation.attributeName === "aria-hidden" || mutation.attributeName === "class" || mutation.attributeName === "open") && handleScroll()
            });
            document.querySelectorAll("cart-drawer, #sidebar-cart, #CartDrawer, .cart-drawer").forEach(drawer => {
                drawerObserver.observe(drawer, {
                    attributes: !0
                })
            }), setTimeout(handleScroll, 300), setInterval(handleScroll, 2e3)
        }
    }
});

function scrollToTop(event) {
    event.preventDefault(), window.scrollTo({
        top: 0,
        behavior: "smooth"
    })
}
window.scrollToTop = scrollToTop;